import React from 'react';
import { SortableElement } from 'react-sortable-hoc';

const DocPage = ({ item, children, itemIndex }) => <>{children(item, itemIndex)}</>;

export default SortableElement(DocPage);
